import React from 'react';
import { BodyContainerComponentsMapping } from './components/BodyContainerComponentsMapping';
import { CamelizedArticleResponse } from '../../../../types/api';
import { LazyYoutube } from '../../../../wag-react/components/lazyload/LazyYoutube';
import { Box } from '../../../../wag-react/next-components/box';
type WellnessArticleBodyContainerProps = Pick<CamelizedArticleResponse, 'body' | 'videoUrl'>;
export const WellnessArticleBodyContainer = ({
  body,
  videoUrl
}: WellnessArticleBodyContainerProps) => <Box data-sentry-element="Box" data-sentry-component="WellnessArticleBodyContainer" data-sentry-source-file="index.tsx">
    {body.map(item => <BodyContainerComponentsMapping key={String(item)} item={item} />)}
    {videoUrl && <LazyYoutube src={videoUrl} my={['24px', '32px']} />}
  </Box>;